import paymentMethods from "@/constants/payment-methods";
import moment from "moment";

const billingEditForm = {
  1: {
    0: {
      type: "text",
      textSize: "big",
      textList: {
        0: {
          text: "Dados da Mensalidade",
          color: "#323232",
        },
      },
    },

    1: {
      type: "form",
      name: "billing-edit",
      form: {
        reference: {
          value: moment().format("YYYY-MM"),
          label: "Mês de Referência",
          name: "reference",
          inputType: "date",
          dateType: "month",
        },
        date: {
          value: moment().format("YYYY-MM-DD"),
          label: "Data do Pagamento",
          name: "date",
          inputType: "date",
          dateMax: new Date(),
        },
        method: {
          value: "pix",
          inputType: "select",
          items: paymentMethods,
          label: "Método de Pagamento",
          name: "method",
        },
        price: {
          value: "",
          label: "Valor",
          inputType: "money",
          name: "price",
        },
      },
    },
    2: {
      type: "buttons",
      buttons: ["previous", "submit"],
    },
  },
};

export default billingEditForm;
